import { normalizeLocaleCode, localesCompatible } from './audio-locale.mjs';

// Saved feedback lives with primary gameData. The wrapper supplies the actual
// loaded content locale; editor/interface locale must never select a recording.
export function getActivityFeedbackAudioPath({
  currentActivity, localeOverride, stringNumber, s3bucketPublicURL,
} = {}) {
  const activity = currentActivity?.activity;
  const data = currentActivity?.data;
  const content = data?.gameData;
  const locale = normalizeLocaleCode(localeOverride);
  if (!activity || !locale || !content) return null;

  const recordingLocale = normalizeLocaleCode(content.feedbackAudioLanguage);
  const storedLocales = [activity.locale, data.activityLocale, content.language]
    .map(normalizeLocaleCode).filter(Boolean);
  // Missing duplicate metadata is unknown, not a conflicting language. Known
  // conflicts still prevent borrowing primary audio for a translated version.
  if (storedLocales.some((value, index) => !localesCompatible(value, locale)
    || storedLocales.slice(index + 1).some(other => !localesCompatible(value, other)))) return null;
  if (recordingLocale && (!localesCompatible(recordingLocale, locale)
    || storedLocales.some(value => !localesCompatible(value, recordingLocale)))) return null;
  if (!storedLocales.length && !recordingLocale) return null;
  // A multilingual activity needs positive recording-language evidence. This
  // applies equally to every template and language, regardless of TTS provider.
  if (!activity.monolingual && !recordingLocale) return null;
  if (!Number.isInteger(Number(stringNumber)) || Number(stringNumber) <= 0) return null;

  const map = content.feedbackAudioByString;
  if (!map || typeof map !== 'object' || Array.isArray(map)
    || !Object.hasOwn(map, String(stringNumber))) return null;
  const filename = map[String(stringNumber)];
  if (typeof filename !== 'string'
    || !/^[A-Za-z0-9][A-Za-z0-9_.-]*\.(mp3|wav|m4a|ogg|webm)$/i.test(filename)) return null;

  const folder = activity.contentFolder;
  if (typeof folder !== 'string' || !folder
    || folder.split('/').some(part => !/^[A-Za-z0-9_-]+$/.test(part))) return null;
  if (typeof s3bucketPublicURL !== 'string' || !/^https?:\/\//.test(s3bucketPublicURL)) return null;
  return `${s3bucketPublicURL.replace(/\/+$/, '')}/${folder}/gamedata/${encodeURIComponent(filename)}`;
}
